module.exports = __webpack_public_path__ + "static/media/toolbar_icon_chat_offline.5a95e561.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterMobile/toolbar_icon_chat_offline.png
// module id = 1566
// module chunks = 1